import { Action, createReducer, on } from '@ngrx/store';

import * as SubmitActions from '../../actions/submit/submit.actions';

export interface ISubmitState {
  isSubmitInProgress: boolean;
  isSubmitSuccessful: boolean;
  isStp: boolean;
}

export const initialState: ISubmitState = {
  isSubmitInProgress: false,
  isSubmitSuccessful: false,
  isStp: false,
};

const submitReducer = createReducer(
  initialState,
  on(SubmitActions.submitInProgress, (state) => {
    return {
      ...state,
      isSubmitInProgress: true,
    };
  }),
  on(SubmitActions.submitCompleted, (state) => {
    return {
      ...state,
      isSubmitInProgress: false,
      isSubmitSuccessful: true,
    };
  }),
  on(SubmitActions.submitFailed, (state) => {
    return {
      ...state,
      isSubmitSuccessful: false,
      isSubmitInProgress: false,
    };
  }),
  on(SubmitActions.updateIsStp, (state, { payload }) => {
    return {
      ...state,
      isStp: payload,
    };
  }),
  on(SubmitActions.resetSubmitState, () => {
    return { ...initialState };
  }),
);

export function reducer(state: ISubmitState | undefined, action: Action) {
  return submitReducer(state, action);
}
